import { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import "@project/index.css";

import { AuthProvider } from "@project/contexts/AuthContext";
import { TooltipProvider } from "@project/components/ui/tooltip";
import { AIAssistantProvider } from "@project/hooks/useAIAssistant";
import { AIAssistantPanel } from "@project/components/AIAssistantPanel";
import { Toaster as Sonner } from "@project/components/ui/sonner";
import { Toaster } from "@project/components/ui/toaster";
import { ConfigProvider } from "antd";

export const ATSProviderWrapper = ({ children }: { children?: ReactNode }) => {
  return (
    <ConfigProvider getPopupContainer={() => document.body}>
      <TooltipProvider>
        <AuthProvider>
          <AIAssistantProvider>
            <Toaster />
            <Sonner />
            {children || <Outlet />}
            <AIAssistantPanel />
          </AIAssistantProvider>
        </AuthProvider>
      </TooltipProvider>
    </ConfigProvider>
  );
};
